const AUTH_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

console.log(AUTH_REDIRECT_URI)

export default AUTH_REDIRECT_URI;
